import { Injectable, inject } from '@angular/core';
import { adminUserApi, adminUserDtos, userApi, userDtos } from '@vectronic/openApi-admin';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UsersRestService {
  private customerUserApi = inject(userApi.Account);
  private adminUserApi = inject(adminUserApi.Users);

  getAllUsers(): Observable<userDtos.UserAccountLight[]> {
    return this.customerUserApi.getLightUsers();
  }

  getSalesUsers(): Observable<adminUserDtos.User[]> {
    return this.adminUserApi.getSalesUsers();
  }
}
